import APIUtils from '@livongo/utilities/system/api';

const SERVICE_URL =
    window?.process?.env?.SERVICE_URL ?? process.env.SERVICE_URL;

const MYSTRENGTH_API_URL =
    window?.process?.env?.MYSTRENGTH_API_URL ?? process.env.MYSTRENGTH_API_URL;

const AxleAPI = {
    getCoachAvailability({
        token,
        startDate,
        endDate,
        reasonCode,
        locale,
        type,
        providerId,
    }) {
        return APIUtils.get(
            `${SERVICE_URL}/service-coaching/v1/appointment/me/availability?start_dt_time=${startDate}&end_dt_time=${endDate}&reason_code=${reasonCode}&locale=${locale}&type=${type}&provider_id=${providerId}`,
            null,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ).then(({data}) => data);
    },
    getAllCoachesAvailability({
        token,
        startDate,
        endDate,
        reasonCode,
        locale,
        type,
    }) {
        return APIUtils.get(
            `${SERVICE_URL}/service-coaching/v1/appointment/me/availability?start_dt_time=${startDate}&end_dt_time=${endDate}&reason_code=${reasonCode}&locale=${locale}&type=${type}`,
            null,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ).then(({data}) => data);
    },
    getLastSessionData({token}) {
        return APIUtils.get(
            `${SERVICE_URL}/service-coaching/v1/appointments/me?status=COMPLETED`,
            null,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ).then(({data}) => data);
    },
    createAppointment(token, appointmentData) {
        return APIUtils.post(
            `${SERVICE_URL}/service-coaching/v1/appointment/me/create`,
            appointmentData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ).then(({data}) => data);
    },
    getCoachingSession(token, calendarId) {
        return APIUtils.get(
            `${SERVICE_URL}/service-coaching/v1/appointment/me/get/${calendarId}`,
            null,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ).then(({data}) => data);
    },
    cancelCoachingSession(token, calendarId) {
        const cancelData = {
            cancel: true,
            // eslint-disable-next-line camelcase
            late_cancel: false,
            reason: 'Member requested cancel',
            notes: '',
            source: 'CCM',
        };

        return APIUtils.post(
            `${SERVICE_URL}/service-coaching/v1/appointment/me/cancel/${calendarId}`,
            cancelData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ).then(({data}) => data);
    },
    getMemberMHSessions(token) {
        return APIUtils.get(
            `${MYSTRENGTH_API_URL}/clinical-coaching/track`,
            null,
            {
                headers: {
                    'x-session-token': token,
                    accept: 'application/json',
                    'x-version': '2',
                },
            }
        ).then(({data}) => data);
    },
    getMHCoachName(token) {
        return APIUtils.get(
            `${MYSTRENGTH_API_URL}/clinical-coaching/coach`,
            null,
            {
                headers: {
                    'x-session-token': token,
                    accept: 'application/json',
                },
            }
        ).then(({data}) => data);
    },
};

export default AxleAPI;
